<div class="error-container">
  <img class="error-icon" src="/assets/images/error/icon.svg" alt="Error 404">
  <div class="error-text" [innerHTML]="'error_Data2' | i18n"></div>
  <div class="error-btn" [innerHTML]="'error_Data3' | i18n" [routerLink]="getRouterLink('Home')"></div>
  <img src="/assets/images/error/folder.svg" alt="Folder" class="folder first">
  <img src="/assets/images/error/folder.svg" alt="Folder" class="folder second">
  <img src="/assets/images/error/folder.svg" alt="Folder" class="folder third">
  <img src="/assets/images/error/folder.svg" alt="Folder" class="folder fourth">
</div>
